import {ChangeDetectionStrategy,ChangeDetectorRef,Component, OnDestroy, OnInit } from "@angular/core";
import { RouterService } from "src/app/libs/data-access/services/router/router.service";
import { PagesRoute } from "src/app/pages/src/app/ui/routes/routes.enum";
import { HotelsFacade } from "../../../data-access/services/hotels.facade";
import { HotelsPageUtil } from "../../../data-access/utils/hotels-page.utils";
import { HotelsPageRoutes } from "../../routes/routes.enum";
import { FiltersOptionsMetadata } from "./hotel-list.config";
import { HomePageUtils } from "src/app/pages/home-page/src/app/ui/utils/home-page.utils";
import { Subject, takeUntil } from "rxjs";
import { TokenStorageService } from "src/app/core/services/token-storage.service";
import { CommunicationService } from "../../communication.service";
import { EventsFacade } from "src/app/pages/events/src/app/data-access/services/events.facade";
import { FlightsFacade } from "src/app/pages/flights-page/src/app/data-access/services/flights.facade";
import { IFilter } from "../../../../../libs/ui/interfaces/filters.interface";
import { CheckoutFacade } from "src/app/libs/data-access/services/checkout/services/checkout.facade";
import { ActivatedRoute, Router } from "@angular/router";
import { HotelsStateActions } from "../../../data-access/store/hotels.actions";
import { Store } from "@ngrx/store";
import { SortOption } from "../../../data-access/model/interfaces/hotel-page.interfacae";
import { HotelsMock } from "../../../data-access/model/interfaces/hotel.interface";
import { FiltersPagesTypes } from "src/app/libs/ui/components/filters-panel/enums/filters-panel.enum";
import { FilterOptionsMetadata } from "src/app/pages/events/src/app/ui/events-page.config";
import { HotelSortOptions } from "../../../data-access/model/consts/hotel-sort.const";
import { HotelsMockData } from "../../../data-access/model/mocks/hotel.mock";
import { TripSummaryComponent } from "src/app/libs/ui/components/trip-summary/trip-summary.component";
import { MatDialog } from "@angular/material/dialog";
import { OfflineDialogComponent } from "src/app/libs/ui/components/offline-dialog/offline-dialog.component";

@Component({
  selector: "tic-hotel-list",
  templateUrl: "./hotel-list.component.html",
  styleUrls: ["./hotel-list.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HotelListComponent implements OnInit, OnDestroy {
  readonly filterOptionsMetadata = FilterOptionsMetadata;
  readonly filtersOptionsMetadata = FiltersOptionsMetadata;
  readonly filtersPagesTypes = FiltersPagesTypes;
  private destroy$ = new Subject();
  showRetryBtn: boolean;
  packageType = [
    'summaryCard.packageType.TicketFlightHotel',
    'summaryCard.packageType.TicketFlight',
    'summaryCard.packageType.TicketHotel',
   ];
  packageIndex!: number;
  params!: Record<string, any>;
  toggleflt = false;
  showsort = false;
  loadedFlight: any;
  loadedEvent: any;
  pspopup = false;
  previousPrices = 0;
  minPrice = 0;
  maxPrice = 10000;
  cheapestHotel: any = {};
  hotelResults: any = [];
  fixedHotelResults: any = [];
  searchMetadata: any = {};
  hotelId!: number;
  hotelsArray: HotelsMock = HotelsMockData;
  data: any;
  storageData: any;
  minval: HTMLDivElement | null;
  maxval: HTMLDivElement | null;
  rangecontainer: HTMLDivElement | null;
  hotelFilterMetaData: IFilter<any>[] = [];
  selectedFilters: any = {};
  selectedSort: any = { price: "asc" };
  sortVal: any = "asc";
  packageMetadata!: any;
  totalAmount: number = 0;
  totalAmountPp!: number;
  currency!: string;
  totalPeoples!: number;
  sortOptions: SortOption[] = HotelSortOptions;
  rpp!: number;
  totalLeftToFetch!: number;
  loadedHotels!: any;
  allLoadedHotels!: any;
  quickFilterSelected!: any;
  totalShown: number = 0;
  isFilterFailed: boolean;
  eventCity: string;
  hotelDefaultFilters: any;
  searchType: string;
  flightPrice: number = 0;
  eventPrice: number = 0;

  constructor(
    private routerService: RouterService,
    private tokenStorage: TokenStorageService,
    public facade: HotelsFacade,
    public flightFacade: FlightsFacade,
    public eventFacade: EventsFacade,
    private changeDetectorRef: ChangeDetectorRef,
    private communicationService: CommunicationService,
    public facadeCheckout: CheckoutFacade,
    private router: Router,
    private store: Store,
    public activatedRoute: ActivatedRoute,
    private matDiaLog: MatDialog,

  ) {
    this.setInitialState();
    this.subscribeToFacadeCheckoutData();
    this.getFilterState();
  }

  ngOnInit(): void {
  }

  private subscribeToFacadeCheckoutData(): void {
    this.facadeCheckout.vm$.pipe(takeUntil(this.destroy$)).subscribe((data) => {
      this.handleFacadeCheckoutData(data);
    });
  }

  private handleFacadeCheckoutData(data: any): void {
    if (data && data.events && data.events.length > 0) {
      this.currency = data.events[0].currency;
      const earliestEvent = this.getEarliestEvent(data.events);
      this.eventCity = earliestEvent.eventData.location.city.name;
    }
    if (data && data.totalPrice) {
      this.totalAmount = data.totalPrice;
      this.totalAmountPp = data.totalPrice / this.totalPeoples;
    }

    if (data && data.eventPrice) {
      this.eventPrice = data.eventPrice;
    }

    if (data && data.flightPrice) {
      this.flightPrice = data.flightPrice;
    }
  }

  getEarliestEvent(events) {
    let earliestEvent = events[0];
    for (let i = 1; i < events.length; i++) {
        const currentDate = new Date(events[i].eventData.date.date);
        const earliestDate = new Date(earliestEvent.eventData.date.date);

        if (currentDate < earliestDate) {
            earliestEvent = events[i];
        }
    }
    return earliestEvent;
  }

  private setInitialState(): void {
    this.storageData = {};
  
    // Subscribe to query parameters
    this.activatedRoute.queryParams.pipe(takeUntil(this.destroy$)).subscribe({
      next: (res: any) => {
        this.data = res;
        this.searchType = res["searchType"];
        // Decode and parse hotelFilter parameter
        if (this.data.hotelFilter) {
          try {
            const base64Data = decodeURIComponent(this.data.hotelFilter);
            const jsonString = atob(base64Data);
            this.hotelDefaultFilters = JSON.parse(jsonString);
          } catch (error) {
            console.error('Error decoding hotelFilter:', error);
          }
        }
  
        // Finalize data and extract required parameters
        this.data = HomePageUtils.finalizedObjectData(this.data);
        this.packageIndex = res["packageType"];
        this.data["flightOfferId"] = res["flightOfferId"];
        this.data["flightOfferPrice"] = res["flightOfferPrice"];
        this.data["eventOfferId"] = res["eventOfferId"];
        this.hotelId = parseInt(res["hotel_id"] || "0", 10);
        this.totalPeoples =
          parseInt(res["numberOfAdults"] || "0", 10) +
          parseInt(res["numberOfChildren"] || "0", 10);
  
        // Handle flights and events data
        if (this.data.flightOfferId) {
          this.getFlightsData(this.data.flightOfferId);
        }
        if (this.data.eventOfferId) {
          this.getEventsData(this.data.eventOfferId);
        }

        // Retrieve data from token storage
        //this.storageData.flightPrice = this.tokenStorage.getData("flightPrice");
        //this.storageData.currency = this.tokenStorage.getData("currency");
      
        // Handle hotels and search metadata
        if (this.data) {
          this.params = { ...this.data, filterObj: this.hotelDefaultFilters };
      
          // Construct request query
          let requestQuery = HotelsPageUtil.getRequestQuery({
            destination: this.params["destination"],
            destinationLocationCode: this.params["destinationLocationCode"],
            inbound: this.params["inbound"].date,
            numberOfAdults: parseInt(this.params["numberOfAdults"] || "1", 10),
            numberOfChildren: parseInt(this.params["numberOfChildren"] || "0", 10),
            numberOfRooms: parseInt(this.params["numberOfRooms"] || "1", 10),
            originLocationCode: this.params["originLocationCode"],
            outbound: this.params["outbound"].date,
            packageType: this.params["packageType"],
            paxesChildrenAges: this.params["paxesChildrenAges"],
          });
      
          const filters = this.hotelDefaultFilters || {};
          this.selectedFilters = filters;
          requestQuery.filters = filters;
      
          // Build paxAges and occupancies
          const paxChildArray = JSON.parse(this.params["paxesChildrenAges"] || "[]");
          const paxAges = [
            ...Array.from({ length: parseInt(this.params["numberOfAdults"] || "1", 10) }, () => ({ type: "AD", age: 30 })),
            ...paxChildArray.map((age: number) => ({ type: "CH", age })),
          ];
      
          const occupancies = [
            {
              rooms: parseInt(this.params["numberOfRooms"] || "1", 10),
              adults: parseInt(this.params["numberOfAdults"] || "1", 10),
              children: parseInt(this.params["numberOfChildren"] || "0", 10),
              paxes: paxAges,
            },
          ];
      
          // Construct metadata
          this.searchMetadata = {
            checkIn: this.params["inbound"].date,
            checkOut: this.params["outbound"].date,
            language: "ENG",
            city: this.params["destination"],
            occupancies,
          };
      
          this.packageMetadata = {
            isPackage: true,
            persons: {
              adults: this.data.numberOfAdults,
              children: this.data.numberOfChildren,
              total: this.totalPeoples,
              totalRooms: parseInt(this.params["numberOfRooms"] || "1", 10),
            },
          };
      
          requestQuery.hotelsCriteria.criteria.occupancies = occupancies;
          requestQuery = {
            ...requestQuery,
            hotelId: this.hotelId,
            packageMetadata: this.packageMetadata,
          };
      
          this.rpp = requestQuery.hotelsCriteria.metadata.rpp;
      
          // Load hotels and filter options
          this.facade.loadHotelFilterOptions(this.searchMetadata);
          this.loadHotels(requestQuery);
        } else {
          this.routerService.navigate(PagesRoute.HomePage);
        }
      },
      error: (error) => {
        console.error('Error fetching query parameters:', error);
        this.routerService.navigate(PagesRoute.HomePage);
      },
    });
  
    // Subscribe to VM state for hotels
    this.facade.vm$.pipe(takeUntil(this.destroy$)).subscribe((data) => {
      if (data?.active) {
        this.loadedHotels = data.active;
        this.allLoadedHotels = data.active;
        this.totalHotelVisible();
      }
    });
  }
  

  private totalHotelVisible() {
    this.totalShown = 0;
    if (this.allLoadedHotels && this.allLoadedHotels.length > 0) {
      this.allLoadedHotels.forEach((hotel) => {
        this.totalShown++;
      });
    }
  }

  private loadHotels(requestQuery: Record<string, any>): void {
    this.facade.loadHotelsData(requestQuery);
  }

  sortHotels(event: any): void {
    this.quickFilterSelected = event.code;
    this.selectedSort = JSON.parse(JSON.stringify(this.selectedSort));
    this.selectedSort = {};
    if(event && event.length > 0) {
      for(let i = 0; i < event.length ; i++ ) {
        const key = event[i].key;
        const value = event[i].value;
        this.selectedSort[key] = value;
      }
    } else {
      const key = event.key;
      const value = event.value;
      this.selectedSort[key] = value;
    }
    //this.sortVal = value;
    this.loadFilteredAndSortHotels(this.selectedFilters, this.selectedSort);
  }

  onScroll(hotel: any) {
    hotel = JSON.parse(JSON.stringify(hotel));
    this.totalLeftToFetch = hotel.totalRecordsLeft;
    hotel.requestMetadata.hotelsCriteria.metadata.page++;
    if (hotel.totalRecordsLeft > 0) {
      this.loadMoreHotels(hotel.requestMetadata);
    }
  }

  private loadMoreHotels(requestQuery: any) {
    this.facade.loadMoreHotelsData(requestQuery);
  }

  trackById(index: number, hotel: any): number | string {
    return hotel.id;
  }

  onSelectedHotel(emitterData: any, hotel: any): void {
    const { flightOfferId, flightOfferPrice } = this.params;
    let updatedPrice = this.eventPrice + this.flightPrice + hotel.rooms[0].rates[0].actualPrice;
    this.facadeCheckout.setTotalPrice(updatedPrice);
    this.facadeCheckout.setHotelPrice(hotel.rooms[0].rates[0].actualPrice);
    this.facadeCheckout.setHotel(hotel);
    const selectedRoom = { name: hotel.rooms[0].apartmentDescription,
      boardName: hotel.rooms[0].rates[0].boardName,
      boardCode: hotel.rooms[0].rates[0].boardCode,
      roomCode: hotel.rooms[0].roomCode,
      price: hotel.rooms[0].rates[0].actualPrice
    }
    this.facadeCheckout.setRoom(selectedRoom);
    
    localStorage.setItem('selectedHotel', JSON.stringify(hotel));
    this.routerService.navigateAndAddParamsToUrl(
      {
        ...emitterData,
        roomData: this.objectToBase64(selectedRoom)
      },
      true,
      `${PagesRoute.HotelsPage}/${HotelsPageRoutes.Hotel_Page}`
    );
  }

  togglefltfunc() {
    this.toggleflt = !this.toggleflt;
  }

  togglesort() {
    this.showsort = !this.showsort;
  }

  private validateRange(
    minPrice: number,
    maxPrice: number,
    minValue: any,
    maxValue: any,
    changeVal?: boolean
  ): void {
    this.maxPrice = maxPrice;
    this.minPrice = minPrice;
    if (minPrice > maxPrice) {
      let tempValue = maxPrice;
      this.maxPrice = maxPrice = minPrice;
      this.minPrice = minPrice = tempValue;
    }
    this.facade.getAllHotels().subscribe((data) => {
      if (data) {
        this.destroy$.next(null);
        let keys = Object.keys(data);
        for (let i = 0; i < keys.length; i++) {
          let id: any = keys[i];
          let existingFlight = this.fixedHotelResults.find(
            (hotels: any) => hotels.id == id
          );
          if (existingFlight == undefined) {
            this.fixedHotelResults.push(data[id]);
          }
        }
      }
    });
    this.hotelResults = this.fixedHotelResults.filter(
      (hotel: any) =>
        hotel.rateRange.minRate / this.hotelsArray.metadata.occupancies.rooms >=
          minPrice &&
        hotel.rateRange.minRate / this.hotelsArray.metadata.occupancies.rooms <=
          maxPrice
    );
    this.hotelResults.sort((a: any, b: any) => a.price - b.price);
    this.cheapestHotel = this.hotelResults[0];
    this.updateContent("priceFilter");
    if (changeVal == undefined) {
      minValue.innerHTML = "$" + minPrice;
      maxValue.innerHTML = "$" + maxPrice;
    }
  }

  private updateContent(data: any) {
    if (data == "priceFilter") {
      this.changeDetectorRef.detectChanges();
    }
  }

  ngAfterViewInit(): void {
    this.communicationService.minval.subscribe((val: any) => {
      this.minval = val;
    });
    this.communicationService.maxval.subscribe((val: any) => {
      this.maxval = val;
    });
    this.communicationService.rangecontainer.subscribe((val: any) => {
      this.rangecontainer = val;
    });
    this.pricerange(this.minval, this.maxval, this.rangecontainer);
  }

  private pricerange(
    minValue: HTMLDivElement | null,
    maxValue: HTMLDivElement | null,
    rangecontainer: HTMLDivElement | null
  ) {
    if (rangecontainer) {
      const inputElements = rangecontainer.querySelectorAll(
        "input"
      ) as NodeListOf<HTMLInputElement>;
      inputElements.forEach((element) => {
        element.addEventListener("change", (e) => {
          let minPrice = parseInt(inputElements[0].value);
          let maxPrice = parseInt(inputElements[1].value);
          this.validateRange(minPrice, maxPrice, minValue, maxValue);
        });
      });

      this.validateRange(
        parseInt(inputElements[0].value),
        parseInt(inputElements[1].value),
        minValue,
        maxValue
      );
    }
  }

  openpspopup() {
    const dialog = this.matDiaLog.open(TripSummaryComponent, {
      width: "90%",
      data: { searchData: this.data },
    });
  }

  closePopupps(): void {
    this.pspopup = false;
  }

  clickedOutps(event: Event) {
    const evt = event.target as HTMLButtonElement;
    if (evt.classList.contains("price-summary")) {
      this.pspopup = false;
    }
  }

  loadAllHotelsFromStore() {
    this.facade.getAllHotels().subscribe((data) => {
      if (data) {
        this.destroy$.next(null);
        let keys = Object.keys(data);
        for (let i = 0; i < keys.length; i++) {
          let id: any = keys[i];
          let existingFlight = this.fixedHotelResults.find(
            (hotels: any) => hotels.id == id
          );
          if (existingFlight == undefined) {
            this.fixedHotelResults.push(data[id]);
          }
        }
      }
    });
  }

  private getEventsData(eventId: string) {
    this.eventFacade.events$.subscribe((data) => {
      this.loadedEvent = data[eventId];
      this.previousPrices =
        +this.previousPrices + this.loadedEvent?.tickets[0].cheapestPrice.price;
    });
  }

  private getFlightsData(flightId: string) {
    this.flightFacade.flights$.subscribe((data) => {
      this.loadedFlight = data[flightId];
      this.previousPrices =
        +this.previousPrices + this.loadedFlight?.total_amount;
    });
  }

  filterSelection(filter: any): void {
    this.selectedFilters = JSON.parse(JSON.stringify(this.selectedFilters));
    this.selectedFilters[filter.id] = filter.value;
    if (this.selectedFilters[filter.id].length == 0) {
      delete this.selectedFilters[filter.id];
    }
    this.loadFilteredAndSortHotels(this.selectedFilters, this.selectedSort);
    const base64Data = this.objectToBase64(this.selectedFilters);
    const currentUrlTree = this.router.parseUrl(this.router.url);
    const queryParams = { ...currentUrlTree.queryParams, hotelFilter: encodeURIComponent(base64Data) };
    const updatedUrlTree = this.router.createUrlTree([], { queryParams, queryParamsHandling: 'merge' });
    const updatedUrl = this.router.serializeUrl(updatedUrlTree);
    window.history.replaceState({}, '', `/#${updatedUrl}`);
  }

  objectToBase64(obj: any): string {
    const jsonStr = JSON.stringify(obj);
    return btoa(jsonStr);
  }

  clearFilterPanel() {
    this.selectedFilters = {};
    this.loadFilteredAndSortHotels(this.selectedFilters, this.selectedSort);
    const base64Data = this.objectToBase64(this.selectedFilters);
    const currentUrlTree = this.router.parseUrl(this.router.url);
    const queryParams = { ...currentUrlTree.queryParams, hotelFilter: encodeURIComponent(base64Data) };
    const updatedUrlTree = this.router.createUrlTree([], { queryParams, queryParamsHandling: 'merge' });
    const updatedUrl = this.router.serializeUrl(updatedUrlTree);
    window.history.replaceState({}, '', `/#${updatedUrl}`);
  }

  clearSingle(event: any) {
    const { [event.info.id]: _, ...rest } = this.selectedFilters;
    this.selectedFilters = rest;
    this.loadFilteredAndSortHotels(this.selectedFilters, this.selectedSort);
    const base64Data = this.objectToBase64(this.selectedFilters);
    const currentUrlTree = this.router.parseUrl(this.router.url);
    const queryParams = { ...currentUrlTree.queryParams, hotelFilter: encodeURIComponent(base64Data) };
    const updatedUrlTree = this.router.createUrlTree([], { queryParams, queryParamsHandling: 'merge' });
    const updatedUrl = this.router.serializeUrl(updatedUrlTree);
    window.history.replaceState({}, '', `/#${updatedUrl}`);
  }

  private loadFilteredAndSortHotels(filter: any, sort: any) {
    if ( !navigator.onLine ) {
      this.matDiaLog.open(OfflineDialogComponent);
      return;
    }
    this.facade.loadFilteredAndSortedHotels(filter, sort);
  }

  quickFilter(event: any) {
    if (event === "cheapest" && this.quickFilterSelected !== "cheapest") {
      const params = {
        key: "price",
        value: "asc",
      };
      this.sortHotels(params);
    } else if(event === "ctc" && this.quickFilterSelected !== "ctc") {
      const params = {
        key: "city",
        value: "ctc",
      };
      this.sortHotels(params);
    } else if(event === "ctep" && this.quickFilterSelected !== "ctep") {
      const params = [
        {
          key: "city",
          value: "ctep",
        },
        {
          key: "eventPlace",
          value: this.eventCity,
        }
      ];
      this.sortHotels(params);
    } else {
      this.loadedHotels = this.allLoadedHotels;
    }
    this.quickFilterSelected = event; 
  }

  navigateToHomePage(): void {
    setTimeout(() => {
      this.router.navigate(["/home-page"]);
    }, 3000);
  }

  retryFilters(): void {
    this.handleNavigationEnd();
  }

  private handleNavigationEnd(): void {
    const segments = this.router.url.split("/");
    const currentPath = segments[segments.length - 1].split("?")[0];
    if (currentPath === HotelsPageRoutes.List) {
      this.showRetryBtn = true;
      this.store.dispatch(
        HotelsStateActions.loadHotelsData({ requestQuery: "Load Hotels Data" })
      );
      this.store.dispatch(
        HotelsStateActions.loadMoreHotelsData({
          requestQuery: "Load More Hotels Data",
        })
      );
    }
  }

  refreshPage(): void {
    window.location.reload();
  }

  private getFilterState(): void {
    this.routerService.isFilterOptions$
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (value: boolean) => {
          this.isFilterFailed = value;
        },
        error: (error) => {
          console.error('Error observing filter state:', error);
        },
      });
  }
  
  isSelectedHotel(hotel: any): boolean {
    let isSelected = false;  // Define a local flag to store the result
  
    // Subscribe to the flight$ observable
    this.facadeCheckout.hotel$.pipe(takeUntil(this.destroy$)).subscribe((hotels:any) => {
      // Check if the flight exists in the array
      if ( hotels && hotels.id === hotel.id ) {
        isSelected = true;  
      }
    });
  
    // Return the flag after the subscription completes
    return isSelected;
  }  

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
}
